export default __webpack_public_path__ + "static/media/share-stats-fr.ddb4d1dd.svg";